import React from "react"

interface CardBrandIconProps {
  brand?: string
  size?: number
}

const CardBrandIcon: React.FC<CardBrandIconProps> = ({ brand, size = 32 }) => {
  const getImagePath = (brandName: string): string => {
    switch (brandName.toLowerCase()) {
      case "visa":
        return "/images/card-brands/visa.png"
      case "mastercard":
        return "/images/card-brands/mastercard.png"
      case "amex":
      case "american express":
        return "/images/card-brands/amex.png"
      case "discover":
        return "/images/card-brands/discover.png"
      case "jcb":
        return "/images/card-brands/jcb.png"
      case "diners":
      case "diners club":
        return "/images/card-brands/diners.png"
      case "unionpay":
        return "/images/card-brands/union.png"
      case "link":
        return "/images/card-brands/link.png"
      default:
        return "/images/card-brands/default.png"
    }
  }

  const getBrandName = (brandName: string): string => {
    switch (brandName.toLowerCase()) {
      case "visa":
        return "Visa"
      case "mastercard":
        return "Mastercard"
      case "amex":
      case "american express":
        return "American Express"
      case "discover":
        return "Discover"
      case "jcb":
        return "JCB"
      case "diners":
      case "diners club":
        return "Diners Club"
      case "unionpay":
        return "UnionPay"
      case "link":
        return "Stripe Link"
      default:
        return "Card"
    }
  }

  if (!brand) {
    return (
      <div
        style={{
          width: size,
          height: size * 0.65, // Maintain card aspect ratio
          backgroundColor: "#6b7280",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "12px",
        }}
      >
        <span style={{ color: "white", fontSize: "12px", fontWeight: "bold" }}>
          ?
        </span>
      </div>
    )
  }

  return (
    <div style={{ marginRight: "12px" }}>
      <img
        src={getImagePath(brand)}
        alt={getBrandName(brand)}
        style={{
          width: size,
          height: size * 0.65, // Credit card aspect ratio (1.586:1)
          objectFit: "contain",
          borderRadius: "4px",
        }}
        onError={(e) => {
          // Fallback to default image if specific brand image fails to load
          const target = e.target as HTMLImageElement

          // Check if we've already handled the error to prevent infinite loops
          if (target.dataset.errorHandled) {
            return
          }

          // First attempt: try default image
          if (!target.dataset.fallbackAttempted) {
            target.dataset.fallbackAttempted = "true"
            target.src = "/images/card-brands/default.png"
          } else {
            // Second attempt failed, show placeholder and mark as handled
            target.dataset.errorHandled = "true"
            target.style.display = "none"
            const parent = target.parentElement
            if (parent) {
              parent.innerHTML = `<div style="width: ${size}px; height: ${size * 0.65}px; background-color: #6b7280; border-radius: 4px; display: flex; align-items: center; justify-content: center;"><span style="color: white; font-size: 12px; font-weight: bold;">?</span></div>`
            }
          }
        }}
      />
    </div>
  )
}

export default CardBrandIcon
